import { WAREHOUSE_PAGE } from "routes/route.constant";
import Warehouse from "./Warehouse";

const route = {
  path: WAREHOUSE_PAGE,
  element: Warehouse,
};

export default route;
